import { MdrContactDetailsFormController } from '../controller/MdrContactDetailsFormController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import {
  MdrContactDetailsFormValuePrivate,
  MdrContactDetailsFormViewData,
  MdrContactDetailsFormValuePublic,
  MdrContactDetailsImportConfig,
} from '../types';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import { Observable } from 'rxjs';

export class MdrContactDetailsFormWebComponent extends BaseWebComponentElement {
  public controller!: MdrContactDetailsFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MdrContactDetailsFormController,
    });
  }

  get valid(): boolean {
    return this.controller.view.formGroup.valid;
  }

  get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  get viewData(): MdrContactDetailsFormViewData | undefined {
    const attributeValue = this.getAttribute('data-view-data');
    return attributeValue ? JSON.parse(attributeValue) : undefined;
  }

  set viewData(value: MdrContactDetailsFormViewData | undefined) {
    if (typeof value !== 'undefined') {
      this.setAttribute('data-view-data', JSON.stringify(value));
    } else {
      this.removeAttribute('data-view-data');
    }
  }

  get hasVerifiedEmailAddress(): boolean {
    const formGroupValue = this.controller.view.formGroup.value as unknown as MdrContactDetailsFormValuePrivate;
    return formGroupValue.hasVerifiedEmailAddress;
  }

  set hasVerifiedEmailAddress(value: boolean) {
    this.controller.view.formGroup.value = {
      hasVerifiedEmailAddress: value,
    };
  }

  get hasStackedFormFields(): boolean {
    return this.hasAttribute('data-has-stacked-form-fields');
  }

  set hasStackedFormFields(value: boolean) {
    if (value) {
      this.setAttribute('data-has-stacked-form-fields', '');
    } else {
      this.removeAttribute('data-has-stacked-form-fields');
    }
  }

  get hasSendButtonBelowEmail(): boolean {
    return this.hasAttribute('data-has-send-button-below-email');
  }

  set hasSendButtonBelowEmail(value: boolean) {
    if (value) {
      this.setAttribute('data-has-send-button-below-email', '');
    } else {
      this.removeAttribute('data-has-send-button-below-email');
    }
  }

  get required(): boolean {
    return this.hasAttribute('data-required');
  }

  set required(value: boolean) {
    if (value) {
      this.setAttribute('data-required', '');
    } else {
      this.removeAttribute('data-required');
    }
  }

  public getFormValue(): MdrContactDetailsFormValuePublic {
    const privateFormValue = this.controller.view.formGroup.value as unknown as MdrContactDetailsFormValuePrivate;
    const { hasVerifiedEmailAddress, ...value } = privateFormValue;

    return value as MdrContactDetailsFormValuePublic;
  }

  public setFormValue(value: Partial<MdrContactDetailsFormValuePublic>): void {
    for (const field of Object.keys(value)) {
      this.controller.view.formGroup.value = {
        [field]: value[field],
      };
    }
  }

  public getFormGroup(): FormGroup {
    return this.controller.view.formGroup;
  }

  public importContactDetails(details: MdrContactDetailsImportConfig): void {
    this.controller.importContactDetails(details);
  }

  public resetFields(): void {
    this.controller.resetFields();
  }
}
